import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * That's the root component for the public space / area of the portal.
 */
@Component({
  selector: 'app-full-background-page',
  imports: [RouterOutlet],
  templateUrl: './full-background-page.component.html',
  styleUrl: './full-background-page.component.scss'
})
export class FullBackgroundPageComponent {}
